.upgrade-section {
    display: grid;
    grid-template-columns: 50% auto;
    justify-content: space-between;
    align-items: center;
}
